import { SelectGroup as AriakitSelectGroup, SelectGroupLabel } from '@ariakit/react';
import cn from 'classnames';
import styles from './SelectGroup.module.css';

type Props = {
  children: React.ReactNode;
  label: string;
  /** Adds a separator after this group */
  hasBottomBorder?: boolean;
};

export function SelectGroup({ children, label, hasBottomBorder }: Props) {
  return (
    <AriakitSelectGroup className={cn({ [styles.SelectGroup___withBottomBorder]: hasBottomBorder })}>
      <SelectGroupLabel className={styles.SelectGroup_label}>{label}</SelectGroupLabel>
      {children}
    </AriakitSelectGroup>
  );
}
